import { render, staticRenderFns } from "./Test3.vue?vue&type=template&id=08af331e&scoped=true"
import script from "./Test3.vue?vue&type=script&lang=js"
export * from "./Test3.vue?vue&type=script&lang=js"
import style0 from "./Test3.vue?vue&type=style&index=0&id=08af331e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af331e",
  null
  
)

export default component.exports